export function isPdfResponse(response) {
  const contentType = response.headers.get('content-type');
  return contentType && contentType.indexOf('application/pdf') !== -1;
}
